












































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Page401'
})
export default class extends Vue {
  public errGif = require('@/assets/401-images/401.gif') + '?' + +new Date()
  public ewizardClap =
    'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646'
  public dialogVisible = false

  public back() {
    if (this.$route.query.noGoBack) {
      this.$router.push({ path: '/dashboard' })
    } else {
      this.$router.go(-1)
    }
  }
}
